// extracted by mini-css-extract-plugin
export default {"rightNavigation":"CarouselRightNav_rightNavigation__bQaYP"};